module.exports = __webpack_public_path__ + "static/img/visit.ad7912a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/visit.png
// module id = yfSL
// module chunks = 2